import React, { useEffect, useState, useRef } from 'react';
import cn from 'classnames';
import './twoPage2.scss';

function TwoPage2(props) {
  const {setCurrentPage, currentFooter} = props;
  console.log('currentFooter: ', currentFooter);

  const [isMob, setIsMob] = useState(false);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      if (window.innerWidth > 1024) {
        setIsMob(false);
      } else {
        setIsMob(true);
      }
      const resizeThrottler = () => {
        if (window.innerWidth < 1024) {
          setIsMob(true);
        } else {
          setIsMob(false);
        }
      };

      window.addEventListener('resize', resizeThrottler, false);
    }

  

  }, []);

  return (
    <>
      <div className="growth-page growth-page--2">
        <div className="growth-page__row">
          <h1 className="growth-page__title _title _growth-anim">Объединение Avito, Slando и OLX</h1>
        </div>
        <div className="growth-page__row growth-page__row--1">
          <div className="growth-page__time _growth-anim">
            <span className="growth-page__month">Март</span>
            <span className="growth-page__year">2013</span>
          </div>
          <h2 className="growth-page__subtitle _large-text _growth-anim">
            «Авито» — лидер на рынке частных объявлений в России
          </h2>
          <div className="growth-page__bg">
            <svg className="_gr-bg _gr-bg--1">
              <use href="/img/icons/icons.svg#_tl-bg-8"></use>
            </svg>
          </div>
        </div>
        <div className="growth-page__row growth-page__row--2">
          <div className="growth-page__col"></div>
          <div className="growth-page__col">
            <p className="growth-page__text _text _growth-anim">
              Активами с&nbsp;&laquo;Авито&raquo; обменивается южноафриканский фонд Naspers.
              За&nbsp;долю &laquo;Авито&raquo; получил OLX.ru и&nbsp;Slando&nbsp;&mdash;
              принадлежавшие Naspers российские сайты частных объявлений, а&nbsp;также $50 млн
              инвестиций.
            </p>
            <div className="quote quote--white growth-page__quote _growth-anim">
              <div className="quote__content">
                <p className="quote__text _text">
                  Это был совершенно естественный процесс объединения двух лидеров
                  на&nbsp;рынке&nbsp;&mdash; и&nbsp;сейчас мы&nbsp;имеем крупнейшую площадку
                  объявлений в&nbsp;России
                </p>
              </div>
              <div className="quote__caption">
                <div className="quote__caption-img">
                  <img
                    src="/img/viktor.png"
                    srcSet="/img/viktor.png 1x, /img/viktor@2x.png 2x"
                    alt="img"
                    className="img"
                  />
                </div>
                <span className="quote__caption-text">Виктор Топадзе</span>
              </div>
            </div>
          </div>
          <div className="growth-page__bg">
            <svg className="_gr-bg _gr-bg--2">
              <use href="/img/icons/icons.svg#_tl-bg-7"></use>
            </svg>
          </div>
        </div>
        <div className="growth-page__row growth-page__row--3">
          <div className="growth-page__time _growth-anim">
            <span className="growth-page__month">Сентябрь</span>
            <span className="growth-page__year">2013</span>
          </div>
          <h2 className="growth-page__subtitle _large-text _growth-anim">
            Модерация <span>по-новому</span>
          </h2>
          <div className="growth-page__bg">
            <svg className="_gr-bg _gr-bg--3">
              <use href="/img/icons/icons.svg#_tl-bg-6"></use>
            </svg>
          </div>
        </div>
        <div className="growth-page__row growth-page__row--4">
          <div className="growth-page__col">
            {!isMob && (
              <div className="growth-page__wrap-img _growth-anim">
                <div className="growth-page__img _growth-anim">
                  <img
                    src="img/two/growth-page-2-1.png"
                    srcSet="img/two/growth-page-2-1.png 1x, img/two/growth-page-2-1@2x.png 2x"
                    alt="img"
                  />
                </div>
              </div>
            )}
          </div>
          <div className="growth-page__col">
            <p className="growth-page__text _text _growth-anim">
              Главой аналитики становится новый сотрудник Иван Гуз. Под его руководством Авито
              запускает автоматизированную модерацию. При этом роль сотрудников модерации
              не&nbsp;снижается.
            </p>
            {isMob && (
              <div className="growth-page__wrap-img">
                <div className="growth-page__img _growth-anim">
                  <img
                    src="img/two/growth-page-2-1.png"
                    srcSet="img/two/growth-page-2-1.png 1x, img/two/growth-page-2-1@2x.png 2x"
                    alt="img _growth-anim"
                  />
                </div>
              </div>
            )}
            <div className="quote quote--white growth-page__quote _growth-anim">
              <div className="quote__content">
                <p className="quote__text _text">
                  Машинное обучение требует оценок, оценки дают люди&nbsp;&mdash; модераторы,
                  квалифицированные специалисты в&nbsp;контенте
                </p>
              </div>
              <div className="quote__caption">
                <div className="quote__caption-img">
                  <img
                    src="/img/roman.png"
                    srcSet="/img/roman.png 1x, /img/roman@2x.png 2x"
                    alt="img"
                    className="img"
                  />
                </div>
                <span className="quote__caption-text">Роман Павлушко</span>
              </div>
            </div>
            <div className="growth-page__wrap">
              <div className="note growth-page__note _growth-anim">
                <p className="note__text _small-text">За год выручка Авито составила</p>
                <p className="note__main">2,4 млн рублей</p>
                <p className="note__text _small-text">
                  Это на 167% больше рублёвого показателя прошлого года.
                </p>
              </div>
              <div className="note growth-page__note _growth-anim">
                <p className="note__text _small-text">
                  К&nbsp;осени в&nbsp;компании выделены отдельные вертикали &laquo;Авито
                  Работа&raquo; и&nbsp;&laquo;Авито Услуги&raquo;
                </p>
              </div>
            </div>
          </div>
          <div className="growth-page__bg">
            <svg className="_gr-bg _gr-bg--4">
              <use href="/img/icons/icons.svg#_tl-bg-20"></use>
            </svg>
          </div>
        </div>
        <div className="growth-page__footer _footer">
          <div className="growth-page__footer-col">
            <div className="growth-page__footer-date">
            2013
            </div>
          </div>
          <div
            className="growth-page__footer-col"
            onClick={() => setCurrentPage({ status: true, el: 3 })}>
            <div className="growth-page__footer-img">
              <img
                src={`img/two/growth-page-footer-3.png`}
                srcSet={`img/two/growth-page-footer-3.png 1x, img/two/growth-page-footer-3@2x.png 2x`}
                alt="img"
              />
            </div>
            <span className="growth-page__footer-year">
            2014
            </span>
            <h3 className="growth-page__footer-title">
            Всероссийский рейтинг автодилеров
            </h3>
          </div>
          <div className="growth-page__footer-col">
            <span
              className="growth-page__footer-date"
              onClick={() => setCurrentPage({ status: true, el: 3 })}>
              Далее
            </span>
          </div>
        </div>
      </div>
    </>
  );
}

export default TwoPage2;
